import axios from 'axios';
import {Write, Remove, Token as TokenKey} from '../../../../utils/localstorage';
import {ApiResultStatus} from './apiStatus';
import {store as Store} from '../../../../App';
import {SIGNOUT_AUTH_SUCCESS} from 'types/actions/Auth.actions';
import {fetchError, showMessage} from 'redux/actions';
import {BaseUrl} from 'shared/constants/AppConst';
import {pageRoutes} from 'containers';
// import { fetchError } from 'redux/actions';

// @ts-ignore
const jwtAxios = axios.create({
  baseURL: BaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

const jwtAxiosFormData = axios.create({
  baseURL: BaseUrl,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

jwtAxios.interceptors.response.use(
  (res) => {
    let message = res?.data?.Message?.toString()?.replace(/\$/g, '');
    if (res?.data?.Message) {
      Store.dispatch(showMessage(message));
    }
    return res;
  },
  (err) => {
    let message = err?.response?.data?.Message?.toString()?.replace(/\$/g, ' ');
    if (
      err.response &&
      err.response.status === ApiResultStatus.UNAUTHORIZED.CODE
    ) {
      Store.dispatch({type: SIGNOUT_AUTH_SUCCESS});
    } // TOKEN EXPIRED
    else if (
      err.response &&
      err.response.status === ApiResultStatus.FAILED.CODE
    ) {
      Store.dispatch(fetchError(message));
    } // FAILED
    else if (
      err.response &&
      err.response.status === ApiResultStatus.CONFLICT.CODE
    ) {
      Store.dispatch(fetchError(message));
    } // CONFLICT IN DATA
    else if (
      err.response &&
      err.response.status === ApiResultStatus.FORBIDDEN.CODE
    ) {
      window.location.href = pageRoutes.ERROR_403;
    } // FORBIDDEN
    else if (
      err.response &&
      err.response.status > ApiResultStatus.INTERNAL_SERVER.CODE
    ) {
      Store.dispatch(fetchError(message));
    } // INTERNAL SERVER ERROR
    return Promise.reject(err);
  },
);

export const setAuthToken = (token: string | null) => {
  if (token) {
    jwtAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    jwtAxiosFormData.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;
    Write(TokenKey, token);
  } else {
    delete jwtAxios.defaults.headers.common['Authorization'];
    delete jwtAxiosFormData.defaults.headers.common['Authorization'];
    Remove(TokenKey);
  }
};

export {jwtAxiosFormData};
export default jwtAxios;
